import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Custom hook to fetch and update driver location
 * Polls every 5 seconds
 */
export function useDriverLocation(driverId) {
  const [driver, setDriver] = useState(null);

  useEffect(() => {
    if (!driverId) return;

    const API = process.env.REACT_APP_API_URL;
    const POLL_INTERVAL = 5000; // 5 seconds

    let timer;
    let inFlight = false;
    let stopped = false;
    const controller = new AbortController();

    const fetchLocation = async () => {
      if (stopped || inFlight) return;
      
      inFlight = true;
      try {
        const response = await axios.get(`${API}/api/location/driver`, {
          params: { driver_id: driverId },
          signal: controller.signal,
        });
        
        if (!stopped) {
          setDriver(response.data);
        }
      } catch (error) {
        if (error?.name !== 'CanceledError' && error?.code !== 'ERR_CANCELED') {
          console.error('Error fetching driver location:', error);
        }
      } finally {
        inFlight = false;
        if (!stopped) {
          timer = setTimeout(fetchLocation, POLL_INTERVAL);
        }
      }
    };

    // Initial fetch
    fetchLocation();

    // Cleanup
    return () => {
      stopped = true;
      controller.abort();
      clearTimeout(timer);
    };
  }, [driverId]);

  return driver;
}